import httpClient from "@utils/httpClient";

interface CompanyInfo {
  id?: number;
  company_name: string;
  company_address: string;
  pincode: string;
  phone_number: string;
  email: string;
  gstin_number: string;
  created_at?: string;
  updated_at?: string;
}

interface ApiResponse {
  success: boolean;
  data: CompanyInfo | null;
  error: { message: string } | null;
}

/**
 * Get company information
 * @returns {Promise<ApiResponse>} Company information
 */
export const getCompanyInfo = async (): Promise<ApiResponse> => {
  try {
    const response = await httpClient.get('/company-info');

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error: any) {
    console.error('getCompanyInfo error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};

/**
 * Update company information
 * @param {Omit<CompanyInfo, 'id' | 'created_at' | 'updated_at'>} companyData - Company information to update
 * @returns {Promise<ApiResponse>} Updated company information
 */
export const updateCompanyInfo = async (
  companyData: Omit<CompanyInfo, 'id' | 'created_at' | 'updated_at'>
): Promise<ApiResponse> => {
  try {
    const response = await httpClient.put('/company-info', companyData);

    return {
      success: response.success,
      data: response.data,
      error: response.error
    };
  } catch (error: any) {
    console.error('updateCompanyInfo error:', error);
    return {
      success: false,
      data: null,
      error: { message: error.message }
    };
  }
};
